//TODO: da finire gestione posizionamento tooltip
import { defineComponent } from "vue";
export default defineComponent({
  name: "BaseTooltip",
  inheritAttrs: false,
  props: {
    theme: {
      type: Object,
      default() {
        return {
          color: "blue",
          size: "sm"
        };
      }
    },
    direction: {
      type: String,
      default: "top"
    },
    customTooltipClass: {
      type: String,
      default: ""
    },
    showTooltipContentManually: {
      type: Boolean,
      default: true
    }
  }
});